import React from "react";
import Annotation from "react-image-annotation";
import _ from "lodash";
import axios from "v2/utils/axios";

export default class DocumentPreview extends React.PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			annotations: [],
			type: [],
			annotation: {}
		};
	}

	getComments() {
		const { document } = this.props;
		axios.get(`${process.env.REACT_APP_API_ENDPOINT_V1}documents/${_.get(document, "id")}/comments`)
			.then((res) => this.setState({ annotations: _.map(res.data.comments, comment => _.get(comment, "metadata.annotation")) }));
	}

	componentDidMount() {
		this.getComments();
	}

	onChange(annotation) {
		this.setState({ annotation });
	}

	onAnnotate(annotation) {
		const { document } = this.props;
		const { geometry, data } = annotation;
		this.setState({
			annotation: {},
			annotations: this.state.annotations.concat({
				geometry,
				data: {
					...data,
					id: Math.random()
				}
			})
		});

		axios.post(`${process.env.REACT_APP_API_ENDPOINT_V1}documents/${_.get(document, "id")}/comments`, 
				{
					comment: {
						body: _.get(annotation, "data.text"),
						metadata: {
							annotation
						}
					}
				});
	}

	render() {
		const { src } = this.props;
		const { annotation, annotations } = this.state;
		return (
			<div className="document-preview">
				<Annotation
					src={src}
					annotations={_.compact(annotations)}
					value={annotation}
					onChange={annotation => this.onChange(annotation)}
					onSubmit={annotation => this.onAnnotate(annotation)}
				/>
			</div>
		);
	}
}
